export const SITE_URL = "https://webdesign-damerow.de";

export const BUSINESS_SCHEMA = {
  "@type": "ProfessionalService",
  "@id": `${SITE_URL}/#business`,
  name: "WebDesign Damerow",
  alternateName: "WebDesign Damerow",
  description:
    "Websites, Online-Buchungssysteme und klar abgegrenzte Automatisierungen für kleine Unternehmen.",
  url: `${SITE_URL}/`,
  email: "kontakt@webdesign-damerow.de",
  priceRange: "ab 490 €",
  areaServed: { "@type": "Country", name: "Deutschland" },
  address: {
    "@type": "PostalAddress",
    streetAddress: "Rosenthaler Straße 15",
    postalCode: "13127",
    addressLocality: "Berlin",
    addressCountry: "DE",
  },
  founder: { "@type": "Person", name: "Armin Damerow" },
  makesOffer: [
    {
      "@type": "Offer",
      name: "Website Starter",
      price: "790",
      priceCurrency: "EUR",
    },
    {
      "@type": "Offer",
      name: "Business Website",
      price: "1290",
      priceCurrency: "EUR",
    },
    {
      "@type": "Offer",
      name: "Online-Buchungssystem",
      price: "990",
      priceCurrency: "EUR",
    },
    {
      "@type": "Offer",
      name: "Automatisierungen & KI",
      price: "490",
      priceCurrency: "EUR",
    },
    {
      "@type": "Offer",
      name: "Individuelle Lösung",
      description: "Preis nach Umfang",
    },
  ],
};

export const HOME_SEO = {
  title: "Webdesign Berlin & digitale Lösungen | WebDesign Damerow",
  description:
    "Websites, Online-Buchungssysteme und Automatisierungen für kleine Unternehmen. Aus Berlin, deutschlandweit. Jetzt unverbindlich anfragen.",
  path: "/",
  schema: {
    "@context": "https://schema.org",
    "@graph": [
      BUSINESS_SCHEMA,
      {
        "@type": "WebSite",
        "@id": `${SITE_URL}/#website`,
        name: "WebDesign Damerow",
        url: `${SITE_URL}/`,
        inLanguage: "de-DE",
        publisher: { "@id": `${SITE_URL}/#business` },
      },
    ],
  },
};

export const SEO_PAGES = {
  unternehmen: {
    slug: "webdesign-fuer-unternehmen",
    eyebrow: "Webdesign für Unternehmen",
    title: "Unternehmenswebsite erstellen lassen | WebDesign Damerow",
    description:
      "Professionelles Webdesign für kleine Unternehmen: klar aufgebaut, mobil optimiert und passend zu Ihrem Betrieb. Persönlich umgesetzt in Berlin.",
    h1: "Eine Unternehmenswebsite erstellen lassen, die Ihr Angebot verständlich macht",
    intro:
      "Eine gute Unternehmenswebsite beantwortet die wichtigsten Fragen Ihrer Kunden schnell: Was bieten Sie an, warum sind Sie die richtige Wahl und wie kann man Sie erreichen? Ich entwickle dafür einen klaren, professionellen Webauftritt, der zu Ihrem Betrieb passt.",
    serviceType: "Webdesign für kleine Unternehmen",
    benefitsTitle: "Was Ihre neue Unternehmenswebsite leisten sollte",
    benefits: [
      ["Klare Seitenstruktur", "Leistungen, Unternehmen und Kontakt sind ohne Umwege erreichbar."],
      ["Professioneller Auftritt", "Gestaltung und Texte vermitteln einen seriösen, einheitlichen Eindruck."],
      ["Mobile Optimierung", "Alle wichtigen Inhalte funktionieren auch auf Smartphone und Tablet zuverlässig."],
      ["Solide SEO-Basis", "Technik, Überschriften und Metadaten werden für Suchmaschinen sauber vorbereitet."],
    ],
    sections: [
      {
        title: "Für Betriebe, die online klarer auftreten möchten",
        text: "Das Angebot richtet sich an kleine Unternehmen, Handwerksbetriebe und lokale Dienstleister. Statt unnötiger Funktionen erhalten Sie eine Website, die sich an Ihren tatsächlichen Zielen und den Fragen Ihrer Kunden orientiert.",
      },
      {
        title: "Mehrseitig und sinnvoll gegliedert",
        text: "Je nach Umfang entstehen eine Startseite sowie passende Unterseiten für Leistungen, Unternehmen und Kontakt. So bekommt jedes Thema ausreichend Raum und Besucher finden schneller die gesuchte Information.",
      },
      {"title": "Wenn mehrere Leistungen eine eigene Erklärung brauchen", "text": "Eine Unternehmenswebsite passt, wenn Kunden unterschiedliche Leistungen, Ihren Betrieb und Kontaktinformationen gezielt nachschlagen sollen. Der Business-Einstieg ab 1.290 € umfasst bis zu fünf Inhaltsseiten, individuelle Gestaltung, mobile Umsetzung, Kontaktformular und Basis-SEO. Weitere Seiten und Funktionen werden gesondert abgestimmt.", "href": "/#pakete", "label": "Pakete und Leistungsumfang vergleichen"},
    ],
    related: ["landingpage", "relaunch", "berlin"],
  },
  landingpage: {
    slug: "landingpage-erstellen-lassen",
    eyebrow: "Landingpage erstellen lassen",
    title: "Landingpage erstellen lassen | WebDesign Damerow Berlin",
    description:
      "Landingpage erstellen lassen: fokussiert, mobil optimiert und mit klarer Nutzerführung. Für Angebote und kleine Unternehmen in Berlin.",
    h1: "Eine Landingpage erstellen lassen, die Ihr Angebot auf den Punkt bringt",
    intro:
      "Eine Landingpage konzentriert sich auf ein konkretes Angebot und ein klares Ziel. Ich entwickle übersichtliche Onepager, die Besucher verständlich durch Inhalte führen und den nächsten Schritt leicht machen – ohne überladene Texte oder unnötige Ablenkung.",
    serviceType: "Erstellung von Landingpages und Onepagern",
    benefitsTitle: "Worauf es bei einer Landingpage ankommt",
    benefits: [
      ["Ein klares Ziel", "Inhalt und Aufbau führen konsequent zu Anfrage, Kontakt oder Termin."],
      ["Verständliche Botschaft", "Besucher erkennen schnell, welches Angebot für sie relevant ist."],
      ["Starke mobile Ansicht", "Kurze Wege und gut bedienbare Kontaktmöglichkeiten auf kleinen Displays."],
      ["Schnelle Orientierung", "Abschnitte, Überschriften und Handlungsaufforderungen greifen logisch ineinander."],
    ],
    sections: [
      {
        title: "Geeignet für einzelne Leistungen und kompakte Auftritte",
        text: "Ein Onepager eignet sich besonders für ein klar definiertes Angebot, eine neue Dienstleistung oder einen kleinen Betrieb mit überschaubaren Inhalten. Wenn mehrere Leistungen ausführlich erklärt werden sollen, ist eine Unternehmenswebsite meist die bessere Lösung.",
      },
      {
        title: "Inhalte, Gestaltung und Technik aus einem Guss",
        text: "Ich strukturiere Ihre vorhandenen Inhalte, gestalte die Seite im Stil Ihres Unternehmens und setze sie responsiv um. Kontaktformular, klare Call-to-Actions und eine technische SEO-Grundlage können direkt eingeplant werden.",
      },
      {"title": "Ein Anlass, ein Angebot, ein nächster Schritt", "text": "Für eine neue Dienstleistung oder einen kompakten ersten Auftritt kann ein Onepager ab 790 € passen. Individuelle Gestaltung, mobile Umsetzung, Kontaktformular und Basis-SEO bilden den Einstieg. Anzeigenbetreuung, Tracking oder eine Erfolgsgarantie sind damit nicht automatisch verbunden.", "href": "/webdesign-fuer-unternehmen", "label": "Wann eine mehrseitige Website sinnvoll ist"},
    ],
    related: ["unternehmen", "berlin", "relaunch"],
  },
  relaunch: {
    slug: "website-relaunch",
    eyebrow: "Website Relaunch",
    title: "Website Relaunch für kleine Unternehmen | WebDesign Damerow",
    description:
      "Website Relaunch mit klarer Struktur, modernem Design und mobiler Optimierung. Für kleine Unternehmen mit einem veralteten Webauftritt.",
    h1: "Website Relaunch: vorhandene Stärken bewahren, Schwächen gezielt verbessern",
    intro:
      "Wenn Ihre Website technisch oder gestalterisch nicht mehr zu Ihrem Unternehmen passt, muss nicht alles verworfen werden. Bei einem Relaunch prüfe ich den bestehenden Auftritt, übernehme sinnvolle Inhalte und entwickle daraus eine klare, moderne Website.",
    serviceType: "Website Relaunch",
    benefitsTitle: "Was bei einem Relaunch verbessert werden kann",
    benefits: [
      ["Struktur und Orientierung", "Gewachsene Inhalte werden geordnet und leichter auffindbar gemacht."],
      ["Zeitgemäße Gestaltung", "Der Auftritt wird modernisiert, ohne Ihre Wiedererkennbarkeit zu verlieren."],
      ["Mobile Nutzbarkeit", "Navigation, Texte und Kontaktwege werden für aktuelle Geräte optimiert."],
      ["SEO sauber weiterführen", "Bestehende URLs und relevante Inhalte werden bei der Planung berücksichtigt."],
    ],
    sections: [
      {
        title: "Bestandsaufnahme vor der Neugestaltung",
        text: "Zu Beginn klären wir, welche Seiten und Inhalte weiterhin gebraucht werden, wo Besucher derzeit aussteigen und welche Ziele der neue Auftritt erfüllen soll. Daraus entsteht ein nachvollziehbarer Relaunch-Umfang.",
      },
      {
        title: "Kein Neustart ohne Blick auf bestehende Sichtbarkeit",
        text: "Wichtige Inhalte, Seitentitel und bestehende Adressen sollten nicht unüberlegt verschwinden. Bei der Umsetzung achte ich auf eine logische Seitenstruktur und eine saubere technische Grundlage für Weiterleitungen und Indexierung.",
      },
      {"title": "Bestehende Adressen vor dem Wechsel erfassen", "text": "Wir halten vorhandene Seiten und ihre künftigen Ziele fest. Wenn sich eine URL ändert, wird eine passende dauerhafte Weiterleitung eingeplant. Interne Links, Canonicals, Sitemap und Indexierungsregeln werden mit geprüft; wichtige Seiten dürfen nicht versehentlich auf eine Fehlerseite zeigen. Zugriff auf Search Console und vorhandene Messdaten klären wir im Projekt. Suchpositionen lassen sich nicht garantieren.", "href": "/webdesign-berlin", "label": "Zusammenarbeit und Projektumfang klären"},
    ],
    related: ["unternehmen", "landingpage", "berlin"],
  },
  berlin: {
    slug: "webdesign-berlin",
    eyebrow: "Webdesign Berlin",
    title: "Webdesign Berlin für kleine Unternehmen | WebDesign Damerow",
    description:
      "Webdesign in Berlin für kleine Unternehmen: professionelle Websites, Relaunch und Landingpages. Persönlich, mobil optimiert und mit klaren Kontaktwegen.",
    h1: "Webdesign in Berlin, das Ihr Unternehmen verständlich präsentiert",
    intro:
      "Ob Handwerksbetrieb, Friseursalon oder lokaler Dienstleister: Ihre Website sollte in wenigen Sekunden zeigen, was Sie anbieten und wie Interessenten Sie erreichen. Ich entwickle moderne, mobil optimierte Websites mit einer klaren Struktur – persönlich aus Berlin und passend zu Ihrem Betrieb.",
    serviceType: "Webdesign in Berlin",
    benefitsTitle: "Was Ihre neue Website für Sie leisten soll",
    benefits: [
      ["Angebot auf den Punkt bringen", "Besucher verstehen schnell, welche Leistungen Sie anbieten und für wen sie gedacht sind."],
      ["Auf dem Handy überzeugen", "Navigation, Inhalte und Kontaktmöglichkeiten bleiben auch auf kleinen Bildschirmen übersichtlich."],
      ["Kontakt einfacher machen", "Gut sichtbare Kontaktwege erleichtern Interessenten den nächsten Schritt zur Anfrage."],
      ["Selbstverständlich auffindbar sein", "Saubere Überschriften, beschreibende Seitentitel und verständliche Inhalte schaffen eine solide SEO-Grundlage."],
    ],
    sections: [
      {
        title: "Websites für Handwerk, Studios und lokale Dienstleister",
        text: "Ein Handwerksbetrieb braucht andere Inhalte als ein Friseursalon oder eine Beratung. Deshalb klären wir zuerst, welche Fragen Ihre potenziellen Kunden haben: Was kostet die Leistung? Wo sind Sie tätig? Wie läuft die Kontaktaufnahme ab? Daraus entsteht eine nachvollziehbare Seitenstruktur.",
      },
      {
        title: "Neue Website oder Relaunch einer bestehenden Seite",
        text: "Sie starten ohne Website? Dann entwickeln wir einen passenden Auftritt von Grund auf. Ihre vorhandene Website ist unübersichtlich oder nicht mehr zeitgemäß? Bei einem Relaunch prüfen wir, welche Inhalte und bestehenden URLs erhalten bleiben sollten und was sich verbessern lässt.",
      },
      {"title": "Ein Onepager ab 790 € – ein kompakter Einstieg", "text": "Für ein überschaubares Angebot: eine individuell gestaltete Seite mit Leistungen und Unternehmensvorstellung, mobiler und Desktop-Ansicht, Kontaktformular und Basis-SEO. Zusätzliche Funktionen werden vorab eingegrenzt.", "href": "/landingpage-erstellen-lassen", "label": "Mehr zu Landingpages und Onepagern"},
      {"title": "Business-Website ab 1.290 € – Raum für mehrere Themen", "text": "Bis zu fünf Inhaltsseiten, individuelle Gestaltung, klare Wege zu Leistungen und Kontakt, mobile und Desktop-Umsetzung, Kontaktformular und Basis-SEO. Die Einstiegspreise gelten für die einmalige Umsetzung des beschriebenen Umfangs; Sie erhalten nach Abstimmung ein konkretes Festpreisangebot.", "href": "/webdesign-fuer-unternehmen", "label": "Mehr zur Unternehmenswebsite"},
      {"title": "Inhalte und Verantwortung gemeinsam klären", "text": "Wir legen fest, welche Texte, Bilder und Logodateien Sie bereitstellen und welche Nutzungsrechte vorliegen. Redaktionelle Unterstützung, zusätzliche Funktionen, Korrekturumfang und Zeitplan werden im Angebot abgestimmt. Die Umsetzung beginnt auf Grundlage des beauftragten Umfangs.", "href": "/kontakt", "label": "Ihr Vorhaben unverbindlich schildern"},
      {"title": "Nach der Übergabe: bearbeiten, pflegen und betreiben", "text": "Ob Sie Inhalte selbst bearbeiten können oder Änderungen beauftragen, hängt von der vereinbarten technischen Lösung ab. Ein CMS ist nicht automatisch enthalten. Domain, Hosting, Kontoinhaberschaft und laufende Kosten klären wir vorab. Pflege und Support werden separat vereinbart.", "href": "/#pakete", "label": "Alle Pakete und Kostenhinweise ansehen"},
    ],
    related: ["unternehmen", "landingpage", "relaunch"],
  }
};

export const PAGE_LABELS = {
  unternehmen: "Webdesign für Unternehmen",
  landingpage: "Landingpage erstellen lassen",
  relaunch: "Website Relaunch",
  berlin: "Webdesign Berlin",
};

/**
 * Shared data for the browser's SEO hook and the static HTML build output.
 * This avoids divergent metadata in the source HTML versus React.
 */
export const buildServiceSchema = (page) => ({
  "@context": "https://schema.org",
  "@graph": [
    BUSINESS_SCHEMA,
    {
      "@type": "Service",
      "@id": `${SITE_URL}/${page.slug}#service`,
      name: page.eyebrow,
      serviceType: page.serviceType,
      description: page.description,
      url: `${SITE_URL}/${page.slug}`,
      provider: { "@id": `${SITE_URL}/#business` },
      areaServed: { "@type": "City", name: "Berlin" },
      audience: { "@type": "BusinessAudience", audienceType: "Kleine Unternehmen" },
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Startseite", item: `${SITE_URL}/` },
        { "@type": "ListItem", position: 2, name: page.eyebrow, item: `${SITE_URL}/${page.slug}` },
      ],
    },
  ],
});

export const CONTACT_SEO = {
  title: "Kontakt | WebDesign Damerow – Webdesigner Berlin",
  description: "Kontakt für Websites, Online-Buchungssysteme und Automatisierungen. Persönliche, unverbindliche Erstberatung durch WebDesign Damerow.",
  path: "/kontakt",
  schema: {
    "@context": "https://schema.org",
    "@graph": [
      BUSINESS_SCHEMA,
      {
        "@type": "ContactPage",
        name: "Kontakt zu WebDesign Damerow",
        url: `${SITE_URL}/kontakt`,
        about: { "@id": `${SITE_URL}/#business` },
        inLanguage: "de-DE",
      },
    ],
  },
};

export const PRIVACY_SEO = {
  title: "Datenschutzerklärung | WebDesign Damerow",
  description: "Informationen zur Verarbeitung personenbezogener Daten bei WebDesign Damerow.",
  path: "/datenschutz",
  schema: null,
  noindex: true,
};

export const DEMO_FRISEUR_SEO = {
  title: "Friseursalon Konzeptprojekt | WebDesign Damerow",
  description: "Nicht indexierbares Konzeptprojekt für die Darstellung einer möglichen Friseursalon-Website.",
  path: "/demo/friseur",
  schema: null,
  noindex: true,
};

export const BERLIN_FAQ = [["Was kostet eine Website?", "Ein individueller Onepager startet ab 790 €, eine Business-Website mit bis zu fünf Inhaltsseiten ab 1.290 €. Beide umfassen mobile Umsetzung, Kontaktformular und Basis-SEO. Der konkrete Umfang und Preis werden vor Beauftragung festgehalten."], ["Welche Inhalte muss ich liefern?", "Sie stellen die abgestimmten Texte, Ihr Logo und passende Bilder mit geklärten Nutzungsrechten bereit. Falls Inhalte fehlen oder redaktionelle Unterstützung benötigt wird, klären wir den zusätzlichen Aufwand im Angebot."], ["Wie laufen Änderungen und Übergabe ab?", "Wir stimmen Entwurf und Inhalte gemeinsam ab. Korrekturumfang, Termine und zusätzliche Änderungswünsche werden im Angebot vereinbart. Es gibt keine pauschale Zusage zu einer festen Zahl von Korrekturrunden."], ["Kann ich Inhalte später selbst ändern?", "Das hängt von der vereinbarten technischen Lösung ab. Eine eigene Bearbeitungsoberfläche ist nicht automatisch enthalten. Wir klären vorab, wer Inhalte aktualisiert und ob ein CMS sinnvoll ist."], ["Wer kümmert sich um Domain und Hosting?", "Wir vereinbaren Anbieter, Kontoinhaberschaft, Zugänge und Zuständigkeiten vor Projektbeginn. Laufende Domain-, Hosting- und Softwarekosten werden vor Beauftragung offengelegt; sie sind nicht pauschal im Umsetzungspreis enthalten."], ["Ist laufende Betreuung enthalten?", "Pflege, spätere Änderungen und technischer Support werden bei Bedarf separat vereinbart. Umfang, Kosten und Reaktionszeiten sind Teil dieser Abstimmung."], ["Wie lange dauert die Umsetzung?", "Den Zeitplan legen wir nach Klärung von Umfang, Funktionen und verfügbaren Inhalten fest. Fehlende Texte, Bilder oder Freigaben können den Ablauf verschieben."], ["Muss ich persönlich in Berlin vorbeikommen?", "Nein. Ich arbeite aus Berlin; Abstimmungen können telefonisch oder online erfolgen. Auch Unternehmen außerhalb Berlins können anfragen."]];
export const CASE_STUDIES = [{"title": "La Bellezza – einen gewachsenen Auftritt ordnen", "task": "Aufgabe: In einer fiktiven Vorher-Nachher-Studie sind Navigation, Angebot und Kontakt zunächst schwer zu erfassen.", "solution": "Lösung: Eine klare Blickführung, größere Typografie und ein sichtbarer nächster Schritt geben denselben Inhalten eine neue Ordnung.", "scope": "Umfang: interaktiver Gestaltungsvergleich, keine vollständige Kundenwebsite und keine gemessenen Geschäftsergebnisse.", "href": "/#vorher-nachher", "label": "Gestaltungsvergleich ansehen"}, {"title": "Atelier Nova – vom Angebot zur Terminwahl", "task": "Aufgabe: Ein fiktiver Salon soll Leistungen, Atmosphäre und den nächsten Schritt verständlich verbinden.", "solution": "Lösung: Eine eigenständige Salon-Demo führt von Leistungen und Galerie zu einer ausprobierbaren Terminwahl.", "scope": "Umfang: Website-Konzept mit lokaler Buchungssimulation. Keine echte Buchung, keine Übermittlung und kein Kundenauftrag.", "href": "/demo/friseur", "label": "Interaktive Salon-Demo öffnen"}];
export const NOT_FOUND_SEO = { title: "Seite nicht gefunden | WebDesign Damerow", description: "Diese Adresse ist nicht verfügbar. Hier finden Sie unsere Leistungen und Kontaktmöglichkeiten.", path: "/404", noindex: true };
